import { companySsoInfoApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectIsMasterCompany } from 'store/auth/selectors';

export const COMPANY_SSO_ACTION_TYPE = createNamedActions('companySso', {
  GET_COMPANY_SSO_INFO: 'GET_COMPANY_SSO_INFO',
  GET_COMPANY_SSO_PROVIDER_INFO: 'GET_COMPANY_SSO_PROVIDER_INFO',
  CREATE_COMPANY_SSO_INFO: 'CREATE_COMPANY_SSO_INFO',
  DELETE_COMPANY_SSO_INFO: 'DELETE_COMPANY_SSO_INFO',
});

export const getCompanySsoProviderInfoAction = catchAsyncActionError(
  ({ companyId }) =>
    async (dispatch, getState) => {
      const state = getState();
      const isMasterCompany = selectIsMasterCompany(companyId)(state);

      const { data } = await (isMasterCompany
        ? companySsoInfoApi.getCompanySsoInfoProviderInfo()
        : companySsoInfoApi.getCompanySsoInfoProviderInfoInternal({ companyId }));

      return dispatch({
        type: COMPANY_SSO_ACTION_TYPE.GET_COMPANY_SSO_PROVIDER_INFO,
        payload: data,
      });
    },
);

export const getCompanySsoInfoAction = catchAsyncActionError(
  ({ companyId }) =>
    async (dispatch, getState) => {
      const state = getState();
      const isMasterCompany = selectIsMasterCompany(companyId)(state);

      const { data } = await (isMasterCompany
        ? companySsoInfoApi.getCompanySsoInfo()
        : companySsoInfoApi.getCompanySsoInfoInternal({ companyId }));

      return dispatch({
        type: COMPANY_SSO_ACTION_TYPE.GET_COMPANY_SSO_INFO,
        payload: data,
      });
    },
);

export const createCompanySsoInfoAction = catchAsyncActionError(
  ({ companyId, ...params }) =>
    async (dispatch, getState) => {
      const state = getState();
      const isMasterCompany = selectIsMasterCompany(companyId)(state);

      const { data } = await (isMasterCompany
        ? companySsoInfoApi.createCompanySsoInfo(params)
        : companySsoInfoApi.createCompanySsoInfoInternal({ companyId, ...params }));

      return dispatch({
        type: COMPANY_SSO_ACTION_TYPE.CREATE_COMPANY_SSO_INFO,
        payload: data,
      });
    },
);

export const deleteCompanySsoInfoAction = catchAsyncActionError(
  ({ id, companyId }) =>
    async (dispatch, getState) => {
      const state = getState();
      const isMasterCompany = selectIsMasterCompany(companyId)(state);

      await (isMasterCompany
        ? companySsoInfoApi.deleteCompanySsoInfo()
        : companySsoInfoApi.deleteCompanySsoInfoInternal({ id }));

      return dispatch({ type: COMPANY_SSO_ACTION_TYPE.DELETE_COMPANY_SSO_INFO });
    },
);
